import { NavOptionsProps } from "../interfaces/navigation";

export const navOptions: NavOptionsProps[] = [
    // {
    //     title: "¿Qué es Linze?",
    //     to: "/linze-ecommerce-chile",
    //     id: "what-is-linze",
    //     realPath: "/linze-ecommerce-chile"
    // },
    {
        title: "Comprar",
        to: "/buscar/autos/usados", 
        id: "autos",
        realPath: ["/buscar/autos/usados", "/buscar/autos/nuevos", "/buscar/comerciales/usados", "/buscar/comerciales/nuevos"] 
    },
    {
        title: "Vender",
        to: "/vender-auto",
        id: "sell",
        realPath: "/vender-auto"
    },
    {
        title: "Tu 0km",
        to: "/marcas-autos-0km",
        id: "brands",
        realPath: "/marcas-autos-0km"
    },
    {
        title: "Comerciales",
        to: "/comerciales",
        id: "comerciales",
        realPath: "/comerciales"
    },
    {
        title: "Servicios",
        to: "/servicios",
        id: "servicios",
        realPath: "/servicios",
    },
    {
        title: "Financiar",
        to: "/financiar-auto",
        id: "financiar",
        realPath: "/financiar-auto"
    },
    {
        title: "Noticias",
        to: "https://blog.linze.cl/",
        id: "noticias",
        realPath: "/noticias",
    },

    // {
    //     title: "LinzeCheck",
    //     to: "/revision-tecnica-auto",
    //     id: "linzeCheck",
    //     realPath: "/revision-tecnica-auto"
    // },
    {
        title: "Notificaciones",
        to: "/notifications",
        id: "notifications",
        realPath: "/notifications",
    },
    {
        title: "Perfil",
        to: "/perfil",
        id: "profile",
        realPath: "/perfil"
    },
    {
        title: "Ingresar",
        to: "/ingresar",
        id: "login",
        realPath: "/ingresar"
    }
];